module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0045.jpg?v=91a23e3c";